<template>
    <b-collapse :visible="showGraph" id="content">
        <card>

            <b-row>
                <b-col cols="12">
                    <card type="default" header-classes="bg-transparent">
                        <b-row slot="header">
                            <b-col>
                                <h5 class="h3 text-white mb-0">History of Prior Authorizations</h5>
                            </b-col>
                            <b-col>
                                <b-dropdown class="float-right" variant="primary" id="dropdown-1" size="sm" :text="selectedDrug">
                                    <b-dropdown-item v-for="(item, index) in bigLineChart.allData" href="#"
                                                     :class="{active: bigLineChart.activeIndex == index}"
                                                     @click.prevent="initBigChart(index), selectedDrug = item.drug">
                                        <a class="nav-item">
                                            {{item.drug}}
                                        </a>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-col>
                        </b-row>
                        <line-chart :height="350"
                                    ref="bigChart"
                                    :chart-data="bigLineChart.chartData">
                        </line-chart>
                    </card>
                </b-col>

                <b-col cols="12" class="mt-4">
                    <card header-classes="bg-transparent">
                        <b-row slot="header" class="align-items-center">
                            <b-col>
                                <!--<h6 class="text-uppercase text-muted ls-1 mb-1">Counts</h6>-->
                                <h5 class="h3 mb-0">PA Status By Drug</h5>
                            </b-col>
                        </b-row>
                        <bar-chart :height="350"
                                   ref="barChart"
                                   :chart-data="redBarChart.chartData"
                                   :extraOptions="redBarChart.extraOptions">
                        </bar-chart>
                    </card>
                </b-col>
            </b-row>
        </card>
    </b-collapse>
</template>

<script>
    import * as chartConfigs from '@/components/Charts/config';
    import LineChart from '@/components/Charts/LineChart';
    import BarChart from '@/components/Charts/BarChart';

    function getBorderColorForStatus(status) {
        if (status === "Approved") return "#69f542";
        if (status === "Denied") return "#ff0000";
        if (status === "Sent To Prescriber") return "#0000ff";
        if (status === "Submitted") return "#00ffff";
        if (status === "Canceled") return "#fe7100";
        if (status === "Abandoned By Prescriber") return "#fec600";
        if (status === "Initiated") return "#898887";
        return "#0000ff";
    }
    function generateColorPalette(startColor, endColor, steps) {
        var start = {
            'Hex': startColor,
            'R': parseInt(startColor.slice(1, 3), 16),
            'G': parseInt(startColor.slice(3, 5), 16),
            'B': parseInt(startColor.slice(5, 7), 16)
        }
        var end = {
            'Hex': endColor,
            'R': parseInt(endColor.slice(1, 3), 16),
            'G': parseInt(endColor.slice(3, 5), 16),
            'B': parseInt(endColor.slice(5, 7), 16)
        }
        let diffR = end['R'] - start['R'];
        let diffG = end['G'] - start['G'];
        let diffB = end['B'] - start['B'];

        let stepsHex = new Array();
        let stepsR = new Array();
        let stepsG = new Array();
        let stepsB = new Array();

        for (var i = 0; i <= steps; i++) {
            stepsR[i] = start['R'] + ((diffR / steps) * i);
            stepsG[i] = start['G'] + ((diffG / steps) * i);
            stepsB[i] = start['B'] + ((diffB / steps) * i);
            stepsHex[i] = '#' + Math.round(stepsR[i]).toString(16) + '' + Math.round(stepsG[i]).toString(16) + '' + Math.round(stepsB[i]).toString(16);
        }
        return stepsHex;
    }

    export default {
        name: 'pa-history-charts',
        
        components: {
            LineChart,
            BarChart
        },
        props: {
            npiNumber: String, 
        },
        data() {
            return {
                selectedDrug: "",
                showGraph: false,
                drugData: [],
                bigLineChart: {
                    allData: [
                        [],
                        []
                    ],
                    activeIndex: 0,
                    chartData: {
                        datasets: [],
                        labels: [],
                    },
                    extraOptions: {
                        maintainAspectRatio: false,
                        legend: {
                            display: true
                        },
                        responsive: true,
                        scales: {
                            yAxes: [{
                                gridLines: {
                                    color: '#525f7f',
                                    zeroLineColor: '#525f7f'
                                },
                                ticks: {
                                    callback: function (value) {
                                        if (!(value % 1)) {
                                            return value;
                                        }
                                    }
                                }
                            }]
                        }
                    },
                },
                redBarChart: {
                    chartData: {},
                    extraOptions: {
                        scales: {
                            x: {
                                stacked: true
                            },
                            y: {
                                stacked: true
                            }
                        }
                    }
                }
            };
        },
        methods: {
            initBigChart(index) {
                this.bigLineChart.chartData = this.bigLineChart.allData[index];
                this.bigLineChart.activeIndex = index;
            },
            fetchData() {
                this.axios.get(`CompanyStats/PAHistory/${this.npiNumber}`)
                    .then(response => {
                        this.drugData = response.data;
                        if (this.drugData[0])
                            this.selectedDrug = this.drugData[0].drugName
                        else
                        {
                            this.selectedDrug = 'No PA History'
                        }
                    })
                    .catch(error => {
                        
                    });
                this.axios.get(`CompanyStats/PAStatusCountsWithDrug/${this.npiNumber}`)
                    .then(response => {
                        let chartData = {
                            datasets: [],
                            labels: [],
                        };
                        if (response.data[0]) {
                            let drugNames = response.data.map(bcd => bcd.drugName).filter((value, index, self) => self.indexOf(value) === index);
                            let statuses = response.data.map(bcd => bcd.statusName).filter((value, index, self) => self.indexOf(value) === index);
                            //2 ways of seeing/filtering data
                            chartData.labels = statuses;
                            let startingColor = '#04a7ff'
                            let endingColor = '#fff200'
                            let steps = drugNames.length + 1
                            let colorPalette = generateColorPalette(startingColor, endingColor, steps)
                            let index = 1

                            //drugNames.forEach(dn => {
                            //    let dataset = {
                            //        label: dn,
                            //        data: [],
                            //        backgroundColor: colorPalette[index],
                            //        borderColor: colorPalette[index],
                            //    };
                            //    index++
                            //    statuses.forEach(status => {
                            //        let selectedDrug = response.data.find(drug => drug.drugName == dn && drug.statusName == status);
                            //        let count = selectedDrug != undefined ? selectedDrug.count : 0;
                            //        dataset.data.push(count);

                            //    });
                            //    chartData.datasets.push(dataset);
                            //});

                            chartData.labels = drugNames;
                            statuses.forEach(status => {
                                let dataset = {
                                    label: status,
                                    data: [],
                                    backgroundColor: getBorderColorForStatus(status),
                                    borderColor: getBorderColorForStatus(status),
                                };

                                drugNames.forEach(l => {
                                    let selectedDrug = response.data.find(drug => drug.drugName == l && drug.statusName == status);
                                    let count = selectedDrug != undefined ? selectedDrug.count : 0;
                                    dataset.data.push(count);

                                });
                                chartData.datasets.push(dataset);
                            });

                            this.redBarChart.chartData = chartData;
                        }
                        else {}
                    })
                    .catch(error => {
                        
                    });
            },

        },
        watch: {
            npiNumber: function () {
                if (this.npiNumber.match(/^[0-9]+$/) != null && this.npiNumber.length === 10 || this.npiNumber.includes(', ')) {
                    this.fetchData();
                }
                else {
                    return false
                }
            },
            drugData: function (drugs) {
                function getBorderColorForStatus(status) {
                    if (status === "Approved") return "#69f542";
                    if (status === "Denied") return "#ff0000";
                    if (status === "Sent To Prescriber") return "#0000ff";
                    if (status === "Submitted") return "#00ffff";
                    if (status === "Canceled") return "#fe7100";
                    if (status === "Abandoned By Prescriber") return "#fec600";
                    if (status === "Initiated") return "#898887";
                    return "#0000ff";
                }
                function groupBy(list, keyGetter) {
                    const map = new Map();
                    list.forEach(item => {
                        const key = keyGetter(item);
                        const collection = map.get(key);
                        if (!collection) {
                            map.set(key, [item]);
                        } else {
                            collection.push(item);
                        }
                    });
                    return map;
                }
                let drugsData = groupBy(drugs, d => d.drugName);
                this.bigLineChart.allData = [];
                let count = [];
                let labels = [];
                drugsData.forEach(e => {

                    let minDateNum = e.reduce((min, d) => d.initiatedY + ((d.initiatedM) / 100) < min ? d.initiatedY + ((d.initiatedM) / 100) : min, e[0].initiatedY + ((e[0].initiatedM) / 100));
                    let maxDateNum = e.reduce((max, d) => d.initiatedY + ((d.initiatedM) / 100) > max ? d.initiatedY + ((d.initiatedM) / 100) : max, e[0].initiatedY + ((e[0].initiatedM) / 100));
                    let dateLabels = [];
                    if (minDateNum === maxDateNum) {
                        if (((minDateNum -= .01) % 1).toFixed(2) == .99) {
                            (minDateNum -= .87).toFixed(2);

                        }
                        if (((maxDateNum += .01) % 1).toFixed(2) == 0.13) {
                            maxDateNum += .88;
                        }
                    }
                    while (minDateNum <= maxDateNum) {
                        let minDateY = Math.floor(minDateNum);
                        let minDateM = Math.round((minDateNum - minDateY) * 100);
                        dateLabels.push(`${minDateM}/${minDateY}`);
                        if ((minDateNum += .01) - minDateY > .12) {
                            minDateNum = Math.floor(minDateNum + 1) + .01;
                        }
                    }
                    let statusGrouped = groupBy(e, d => d.statusName);
                    let dataToPush = {
                        labels: dateLabels,
                        datasets: [],
                        drug: e[0].drugName
                    };


                    statusGrouped.forEach(sg => {
                        let datasetToPush = { backgroundColor: getBorderColorForStatus(sg[0].statusName) + "4B", borderColor: getBorderColorForStatus(sg[0].statusName), label: sg[0].statusName, data: [] };
                        dataToPush.labels.forEach(lab => {
                            let added = false;
                            sg.forEach(d => {
                                if (lab === `${d.initiatedM}/${d.initiatedY}`) {
                                    datasetToPush.data.push(d.count);
                                    added = true;
                                }
                            });
                            if (added === false) {
                                datasetToPush.data.push(0);
                            }

                        });
                        dataToPush.datasets.push(datasetToPush);
                    });
                    this.bigLineChart.allData.push(dataToPush);

                });
                if (this.bigLineChart.allData.length == 0) {
                    this.bigLineChart.allData = [{
                        chartData: {
                            datasets: [],
                            labels: [],
                        },
                    }];
                    this.bigLineChart.chartData = {
                        datasets: [],
                        labels: [],
                    };
                    this.showGraph = false;
                } else {
                    this.initBigChart(0)
                    this.showGraph = true;
                }
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>
</style>